import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import {FaFacebook} from 'react-icons/fa';
import SafeIcon from '../common/SafeIcon';

const {FiMapPin,FiStar,FiClock,FiPhone,FiGlobe,FiNavigation,FiMail}=FiIcons;

function GoogleBusinessCard() {
  const businessHours=[
    {day:'Monday',hours:'9:00 AM - 5:00 PM'},
    {day:'Tuesday',hours:'9:00 AM - 5:00 PM'},
    {day:'Wednesday',hours:'9:00 AM - 5:00 PM'},
    {day:'Thursday',hours:'9:00 AM - 5:00 PM'},
    {day:'Friday',hours:'9:00 AM - 5:00 PM'},
    {day:'Saturday',hours:'Closed'},
    {day:'Sunday',hours:'Closed'}
  ];

  const today=new Date().getDay();
  const adjustedDay=today===0?6:today-1;

  return (
    <motion.div initial={{opacity:0,y:20}} animate={{opacity:1,y:0}} transition={{duration:0.5}} className="bg-dark-card border border-dark-border rounded-lg overflow-hidden">
      <div className="relative h-48">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d635.7891655882447!2d-74.00930080059098!3d40.71053124832778!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25b1ad87ecbb7%3A0x8241fbe9cf4bd006!2sBoroughTV!5e0!3m2!1sen!2sus!4v1753040195672!5m2!1sen!2sus"
          width="100%"
          height="100%"
          style={{border:0}}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="BoroughTV Office Location"
          className="absolute inset-0"
        />
      </div>

      <div className="p-6">
        <div className="flex justify-between items-start mb-4">
          <div>
            <h3 className="text-xl font-bold">BoroughTV</h3>
            <div className="flex items-center mt-1">
              <div className="flex text-yellow">
                <SafeIcon icon={FiStar} />
                <SafeIcon icon={FiStar} />
                <SafeIcon icon={FiStar} />
                <SafeIcon icon={FiStar} />
                <SafeIcon icon={FiStar} className="text-gray-400" />
              </div>
              <span className="text-gray-400 text-sm ml-2">4.0 (12 reviews)</span>
            </div>
          </div>
          <a href="https://maps.app.goo.gl/7qocMCVnLHM7nwHH9" target="_blank" rel="noopener noreferrer" className="bg-accent-blue text-white px-3 py-1 rounded-full text-sm flex items-center">
            <SafeIcon icon={FiNavigation} className="mr-1" />
            Directions
          </a>
        </div>

        <div className="space-y-3 mb-4">
          <div className="flex items-start space-x-3">
            <SafeIcon icon={FiMapPin} className="text-accent-blue mt-1 flex-shrink-0" />
            <span className="text-gray-300">200 Broadway,Floor 3,New York,NY 10038</span>
          </div>
          <div className="flex items-start space-x-3">
            <SafeIcon icon={FiPhone} className="text-accent-blue mt-1 flex-shrink-0" />
            <span className="text-gray-300">332-378-0003</span>
          </div>
          <div className="flex items-start space-x-3">
            <SafeIcon icon={FiMail} className="text-accent-blue mt-1 flex-shrink-0" />
            <span className="text-gray-300">info@boroughtv.nyc</span>
          </div>
          <div className="flex items-start space-x-3">
            <SafeIcon icon={FiGlobe} className="text-accent-blue mt-1 flex-shrink-0" />
            <a href="https://boroughtv.nyc" className="text-accent-blue hover:underline">boroughtv.nyc</a>
          </div>
          <div className="flex items-center space-x-3 mt-1">
            <a href="https://www.facebook.com/BoroughTV/" target="_blank" rel="noopener noreferrer" className="text-accent-blue hover:text-white transition-colors">
              <FaFacebook className="text-xl" />
            </a>
          </div>
        </div>

        <div className="mb-4">
          <div className="flex items-center mb-2">
            <SafeIcon icon={FiClock} className="text-accent-blue mr-2" />
            <h4 className="font-semibold">Business Hours</h4>
          </div>
          <div className="text-sm space-y-1 pl-6">
            {businessHours.map((item,index)=>(
              <div key={item.day} className={`flex justify-between ${index===adjustedDay?'text-accent-blue font-medium':'text-gray-400'}`}>
                <span>{item.day}</span>
                <span>{item.hours}</span>
              </div>
            ))}
          </div>
        </div>

        <a href="https://maps.app.goo.gl/7qocMCVnLHM7nwHH9" target="_blank" rel="noopener noreferrer" className="block w-full bg-dark-bg text-center py-2 rounded text-accent-blue hover:bg-accent-blue/10 transition-colors">
          View on Google Maps
        </a>
      </div>
    </motion.div>
  );
}

export default GoogleBusinessCard;